import * as React from "react";
const SvgFiRrMoneyTransferSmartphone = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-money-transfer-smartphone_svg__a)">
      <path
        fill="#062147"
        d="M4 7V5c0-2.757 2.243-5 5-5h6c1.22 0 2.395.444 3.308 1.25a1.001 1.001 0 0 1-1.324 1.499 3 3 0 0 0-1.983-.75h-6c-1.654 0-3 1.346-3 3v2a1 1 0 1 1-2 0zm15 5a1 1 0 0 0-1 1v6c0 1.654-1.346 3-3 3H9c-1.654 0-3-1.346-3-3a1 1 0 1 0-2 0c0 2.757 2.243 5 5 5h6c2.757 0 5-2.243 5-5v-6a1 1 0 0 0-1-1m-3.738.21c-.16-.853-.889-1.551-1.812-1.735l-2.688-.539a.574.574 0 0 1 .112-1.136h2.204c.223 0 .434.107.564.287.142.193.433.213.552.213a.8.8 0 0 0 .732-.476.765.765 0 0 0-.121-.841 2.3 2.3 0 0 0-1.728-.782H12.8v-.7a.8.8 0 0 0-1.6 0v.7h-.327a2.174 2.174 0 0 0-2.135 2.59c.159.853.887 1.55 1.812 1.735l2.688.538a.575.575 0 0 1-.112 1.137h-2.204a.7.7 0 0 1-.564-.287c-.142-.193-.433-.213-.552-.213a.8.8 0 0 0-.732.477.76.76 0 0 0 .122.84 2.3 2.3 0 0 0 1.727.783h.278v.7a.8.8 0 0 0 1.6 0v-.7h.326c.647 0 1.257-.287 1.673-.787a2.19 2.19 0 0 0 .463-1.803zm8.21-6.514-2.244-2.382a1 1 0 1 0-1.455 1.372L21.011 6H18a1 1 0 1 0 0 2h3.011l-1.238 1.314a1 1 0 1 0 1.456 1.372l2.224-2.36c.354-.354.55-.825.55-1.326s-.195-.972-.529-1.304zM4.228 15.314 2.99 14h3.011a1 1 0 1 0 0-2h-3.01l1.238-1.314a1 1 0 0 0-1.455-1.372l-2.223 2.36c-.354.354-.55.825-.55 1.326s.195.972.529 1.304l2.243 2.381a.999.999 0 1 0 1.456-1.372zM11 18a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-money-transfer-smartphone_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMoneyTransferSmartphone;
